export const projects = [
  {
    title: 'This is Article 1 with Xeno Robotics',
    source: 'Source 1',
    href: 'https://google.com',
  },
  {
    title: 'This is Article 2 with Xeno Robotics',
    source: 'Source 2',
    href: 'https://google.com',
  },
  {
    title: 'This is Article 3 with Xeno Robotics',
    source: 'Source 3',
    href: 'https://google.com',
  },
  {
    title: 'This is Article 4 with Xeno Robotics',
    source: 'Source 4',
    href: 'https://google.com',
  },
  {
    title: 'This is Article 5 with Xeno Robotics',
    source: 'Source 5',
    href: 'https://google.com',
  },
  {
    title: 'This is Article 6 with Xeno Robotics',
    source: 'Source 6',
    href: 'https://google.com',
  },
  {
    title: 'This is Article 7 with Xeno Robotics',
    source: 'Source 7',
    href: 'https://google.com',
  },
  {
    title: 'This is Article 8 with Xeno Robotics',
    source: 'Source 8',
    href: 'https://google.com',
  },
];
